import { render, staticRenderFns } from "./bubble_pop.score.vue?vue&type=template&id=12edb4fa&scoped=true"
import script from "./bubble_pop.score.vue?vue&type=script&lang=js"
export * from "./bubble_pop.score.vue?vue&type=script&lang=js"
import style0 from "./bubble_pop.score.vue?vue&type=style&index=0&id=12edb4fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12edb4fa",
  null
  
)

export default component.exports